<template>
  <div></div>
  <!-- We don't need a footer for the app, it is common for web sites,
  but not for apps, especially on mobile and in native apps.
  -->
  <!--footer class="footer">
    <div style="display: none">{{ appVersion }}</div>
    <div class="container">
      <div class="footer__logo-btn">
        <div class="footer__logo-box">
          <img src="@/assets.app/images/logo.svg" alt="Shortform App" />
        </div>
        <div class="footer__btn-box">
          <a
            href="https://apps.apple.com/app/shortform/id1489472007"
            target="_blank"
            title="Download from App Store"
            class="footer__btn btns"
            ><img
              class="footer__btn-img"
              src="@/assets.app/images/app-store.svg"
              alt=""
          /></a>
          <a
            href="https://play.google.com/store/apps/details?id=com.shortform.app"
            target="_blank"
            title="Get in on Google Play"
            class="footer__btn btns"
            ><img
              class="footer__btn-img"
              src="@/assets.app/images/google-play.svg"
              alt=""
          /></a>
        </div>
      </div>
      <div class="copyright">
        <p class="copyright__text">
          © 2020 Shortform |
          <router-link :to="{ name: 'site_terms' }"
            >Terms & Conditions</router-link
          >
          |
          <router-link :to="{ name: 'site_privacy' }">Privacy</router-link>
        </p>
      </div>
    </div>
  </footer-->
</template>
